/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';

import { useInstallerDownload } from '@/hooks/useInstallerDownload';
import { Tooltip } from '@/primitives/Tooltip';

type InstallerDownloadIconProps = {
  releaseId: string;
};

export function InstallerDownloadIcon({ releaseId }: InstallerDownloadIconProps) {
  const { state, startDownload } = useInstallerDownload();

  const isBuilding = state.status === 'building';

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isBuilding) {
      startDownload(releaseId);
    }
  };

  const tooltipTitle = isBuilding ? 'Building installer...' : 'Download installer (legacy)';

  return (
    <Tooltip title={tooltipTitle}>
      {isBuilding ? (
        <LoadingOutlined
          style={{
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.45)',
          }}
        />
      ) : (
        <DownloadOutlined
          onClick={handleClick}
          data-testid="download-release-hash"
          style={{
            fontSize: '12px',
            color: 'rgba(0, 0, 0, 0.45)',
            cursor: 'pointer',
          }}
        />
      )}
    </Tooltip>
  );
}
